import { clamp } from './cosmicMath';

export const cinematicDelays = {
  eyebrow: 160,
  colorWheel: 260,
  hero: 360,
  orbit: 720,
  title: 980,
  copy: 1320,
  primaryAction: 1640,
  secondaryAction: 1810,
  statusStatic: 2150,
  statusExperiment: 2350,
  statusMotion: 2550,
  statusDemo: 2750,
  aiGuide: 2960,
} as const;

export type CinematicCue = keyof typeof cinematicDelays;

export function getCinematicDelay(cue: CinematicCue): number {
  return cinematicDelays[cue];
}

export function getCinematicDelayValue(cue: CinematicCue): string {
  return `${getCinematicDelay(cue)}ms`;
}

export function getCinematicIntroProgress(elapsedSeconds: number, durationSeconds = 3.4): number {
  if (durationSeconds <= 0) {
    return 1;
  }

  return clamp(elapsedSeconds / durationSeconds, 0, 1);
}

export function applyCinematicTimeline(root: ParentNode = document): number {
  const cues = root.querySelectorAll<HTMLElement>('[data-cinematic]');

  cues.forEach((element) => {
    const cue = element.dataset.cinematic as CinematicCue;

    if (cue in cinematicDelays) {
      element.style.setProperty('--cinematic-delay', getCinematicDelayValue(cue));
      element.dataset.cinematicReady = 'true';
    }
  });

  return cues.length;
}
